<script setup lang="ts">
import { useCreditSimulator } from '~/composables/credit';

import IconMaterialSymbolsLightCheck from '~icons/material-symbols-light/check';

import { CREDIT_PRODUCT_NAMES, CREDIT_WHATSAPP_URL } from '../content';

const simulator = useCreditSimulator();
const productName = computed(
	() => CREDIT_PRODUCT_NAMES[simulator.state.value.product]
);

const heading = useTemplateRef<HTMLElement>('heading');
defineExpose({ focusHeading: () => heading.value?.focus() });
</script>

<template>
	<div class="flex flex-col gap-4.5 py-2">
		<div
			class="flex size-14 items-center justify-center rounded-full bg-beige/12"
		>
			<IconMaterialSymbolsLightCheck
				class="size-7 text-beige"
				aria-hidden="true"
			/>
		</div>
		<div
			ref="heading"
			tabindex="-1"
			class="font-[Inter,sans-serif] text-[30px] leading-[1.2] font-normal tracking-[-0.02em] outline-none"
		>
			Recebemos sua simulação.
		</div>
		<div class="text-[15px] leading-[1.6] text-[#D4D4D4]">
			Um especialista Pilar vai chamar você no WhatsApp, em dias úteis das 9h às
			18h, com as primeiras propostas para {{ productName }}.
		</div>
		<div class="rounded-xs bg-[#1F1F1F] px-4.5 py-4">
			<div class="text-[14px] font-medium">Para agilizar, já separe:</div>
			<ul
				class="mt-2 mb-0 list-disc pl-4.5 text-[14px] leading-[1.8] text-[#D4D4D4]"
			>
				<li>RG ou CNH e CPF</li>
				<li>Comprovantes de renda dos últimos 3 meses</li>
				<li>Comprovante de residência</li>
			</ul>
		</div>
		<a
			:href="CREDIT_WHATSAPP_URL"
			target="_blank"
			rel="noopener noreferrer"
			class="flex min-h-13 items-center justify-center rounded-xs bg-beige text-[16px] font-medium text-black no-underline"
		>
			Prefiro agendar um horário
		</a>
		<button
			type="button"
			class="min-h-11 cursor-pointer border-none bg-transparent text-[15px] font-medium text-beige underline"
			@click="simulator.restart()"
		>
			Fazer outra simulação
		</button>
	</div>
</template>
